module.exports = __webpack_public_path__ + "images/accents/accent-kiwis@2x-40dc1865d495673d6922cd444227316d.webp";